import { EventState } from 'graphql/generated'
import { useEventContext } from 'context/EventContext'
import { faEdit } from '@fortawesome/pro-solid-svg-icons'
import ModalTrigger from 'components/common/ModalTrigger'
import { EventInputModal } from './EventInputModal/EventInputModal'
import RoundedIconButton from 'components/common/RoundedIconButton'

const EditButton: React.FC = () => {
  const { event } = useEventContext()

  const hasEnded = event.state === EventState.ENDED
  const showEditButton = !hasEnded && event.canEdit
  if (!showEditButton) {
    return null
  }

  return (
    <ModalTrigger
      trigger={onClick => (
        <RoundedIconButton
          color="lightGray"
          className="text-gray-700"
          onClick={onClick}
          size={'xs'}
          icon={faEdit}
        />
      )}
    >
      <EventInputModal event={event} collective={event.collective} />
    </ModalTrigger>
  )
}

export default EditButton
